<div
  class="gs-loader"
  [class.gs-loader-contained]="mode() === 'contained'"
  role="status"
  [attr.aria-label]="label()">
  <span class="gs-loader-spinner" aria-hidden="true"></span>
</div>
